import React from 'react';
import PropTypes from 'prop-types';
import { SidebarMenu } from 'reactifi-local';
import { customerAdminLeft } from '../menus/customerAdminLeft';
import { filterMenu, withPermissionIndicator } from '../menus/menuHelper';

/**
 * Wraps SidebarMenu and builds menuData for customer_admin_left from context props,
 * removing the dependency on foundry-universal_navigation gem.
 */
const SidebarMenuWithMenuData = props => {
  const {
    user,
    organization,
    adminifiDomain,
    contentServiceDomain,
    notifiDomain,
    engageDomain,
    nextDomain,
    dashifiDomain,
    currentRuleSetName,
    currentUrl,
    locale,
    ...rest
  } = props;

  const menuDefinition = customerAdminLeft({
    adminifiDomain,
    contentServiceDomain,
    notifiDomain,
    engageDomain,
    nextDomain,
    dashifiDomain,
  });

  const filtered = filterMenu(menuDefinition, {
    user,
    organization,
    currentRuleSetName,
    locale,
    engageDomain,
    nextDomain,
  });

  const menuData = withPermissionIndicator(filtered, currentUrl);

  return <SidebarMenu {...rest} menuData={menuData} currentUrl={currentUrl} />;
};

SidebarMenuWithMenuData.propTypes = {
  user: PropTypes.object,
  organization: PropTypes.object,
  adminifiDomain: PropTypes.string,
  contentServiceDomain: PropTypes.string,
  notifiDomain: PropTypes.string,
  engageDomain: PropTypes.string,
  nextDomain: PropTypes.string,
  dashifiDomain: PropTypes.string,
  currentRuleSetName: PropTypes.string,
  lastRuleSetName: PropTypes.string,
  currentUrl: PropTypes.string,
  locale: PropTypes.string,
};

export default SidebarMenuWithMenuData;
